// import { createApp } from 'vue';
import Antd from 'ant-design-vue'
import Vue from 'vue'
import App from './App'
import router from './router'
import md5 from 'js-md5'
import 'ant-design-vue/dist/antd.css'
import VueCookies from 'vue-cookies'

// const app = createApp();
// app.config.productionTip = false;
Vue.prototype.$md5 = md5

Vue.use(Antd)
Vue.use(VueCookies)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})

// 路由守卫
router.beforeEach((to, from, next) => {
  if (to.meta.auth) {
    // 判断该路由是否需要登录权限
    const token = VueCookies.get('token')
    if (token) {
      next()
    } else {
      next({
        path: '/login'
      })
    }
  } else {
    next()
  }
})

// 移动端适配

resizeHtml()

window.onresize = resizeHtml

function resizeHtml() {
  // 320 20px

  document.documentElement.style.fontSize = screen.availWidth / 320 * 20 + 'px'
}



// WEBPACK FOOTER //
// ./src/main.js